<template>
  <div class="csr-with-balance-container csr-input-aside-return-texts">
      <!-- <input-csr @input-csr-changed="queryBalance" :store-name="storeName" :isRequire="isRequire"></input-csr> -->
      <InputSelectRemoteSuggestion
      v-bind="{...$props, ...$attrs, title:'To CSR'}"
      @select-changed="handleCsrChanged"
      class="special-emphasize-input-text"
      width="195"
      />
      <div class="next">
        <!-- <span>Price&nbsp;</span> -->
        <span class="strong1">{{priceType}}</span>
        <span>&nbsp;|&nbsp;</span>
        <span>&nbsp;</span>
        <span class="strong1">{{areaType}}</span>
        <span>&nbsp;|&nbsp;</span>
        <span>Pay&nbsp;</span>
        <span class="strong1">{{payType}}</span>
        <span>&nbsp;|&nbsp;</span>
        <span>Limit&nbsp;</span>
        <span class="strong2">{{creditLimit}}</span>
        <span>&nbsp;|&nbsp;</span>
        <span>Xero&nbsp;</span>
        <span :class="[xeroBalance === 0 ? 'strong2' : 'strong3']">{{xeroBalance}}</span>
      </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { getBalance } from '../api'
import InputSelectRemoteSuggestion from './InputSelectRemoteSuggestion'

export default {
  name: 'InputCsrWithBalance',
  components: {
    InputSelectRemoteSuggestion
  },
  data () {
    return {
      creditLimit: '',
      xeroBalance: '',
      priceType: '',
      payType: '',
      areaType: '',
      event: 'customer-selected-changed'
    }
  },
  props: {
    width: {
      type: Number,
      default: 195
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapMutations({
      setDueDate: 'edit/setDueDate',
      setDueDateByPayType: 'edit/setDueDateByPayType',
      setCsrCreditLimit: 'edit/setCsrCreditLimit',
      setCsrXeroBalance: 'edit/setCsrXeroBalance'
    }),
    handleCsrChanged (csr) {
      // go on emit it
      this.payType = csr.paymentType
      this.areaType = csr.areaType
      this.priceType = csr.priceType
      if (this.$route.name !== 'OrderDetail') {
        this.queryBalance(csr)
        this.setDueDateByPayType(csr.paymentType)
      }
    },
    async queryBalance (csr) {
      const id = csr.id || 0
      if (id > 0) {
        const data = (await getBalance(id)).data
        this.creditLimit = data.creditLimit
        this.xeroBalance = data.xeroBalance
        this.setCsrCreditLimit(data.creditLimit)
        this.setCsrXeroBalance(data.xeroBalance)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.csr-with-balance-container {
  display: flex;
}
</style>
